<div class="main-table-container">
  @if (!loading) {
    <table class="content-table">
      <thead>
        <tr>
          @if (dataSource.tableConfig.multiSelect) {
            <th>
              <app-tri-value-checkbox [dataSource]="dataSource"></app-tri-value-checkbox>
            </th>
          }
          @if (dataSource?.tabSelected?.tableView?.expandable) {
            <th class="expand-column"></th>
          }
          @for (field of this.getTableDisplayFields(); track field) {
            <th [style]="transform(field.tableCss)">
              <div [class.header-label]="field.sortable">
                <span (click)="onSortChange(field)">{{ field.label }}</span>
                @if (field.name === activeSort?.fieldConfig.name && activeSort?.direction === 'ASC') {
                  <span><i class="fas fa-arrow-up"></i></span>
                }
                @if (field.name === activeSort?.fieldConfig.name && activeSort.direction === 'DESC') {
                  <span><i class="fas fa-arrow-down"></i></span>
                }
              </div>
            </th>
          }
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (dataSource.pageData?.length === 0) {
          <tr>
            <td class="info-row" [colSpan]="this.getTableDisplayFields().length + 2">Nothing to display</td>
          </tr>
        }
        @for (element of dataSource.pageData; track element) {
          <tr
            [@updatingIdle]="element.updating ? 'updating' : 'idle'"
            [style.background-color]="getBackgroundColor(element)">
            @if (dataSource.tableConfig.multiSelect) {
              <td>
                <mat-checkbox [(ngModel)]="element.checked" (ngModelChange)="bulkCheckboxClick($event)"></mat-checkbox>
              </td>
            }
            @if (dataSource?.tabSelected?.tableView?.expandable) {
              <td class="expand-column" (click)="expandElement(element)">
                @if (!element.expanded) {
                  <i class="fas fa-angle-right"></i>
                }
                @if (element.expanded) {
                  <i class="fas fa-angle-down"></i>
                }
              </td>
            }
            @for (field of this.getTableDisplayFields(); track field) {
              <td [style]="transform(field.tableCss)" [attr.data-id]="'fieldName_' + field.name">
                <app-table-cell
                  [rowData]="element.data"
                  [type]="field.type"
                  [data]="element.data[field.name]"
                  [attr.data-id]="'appTableCellData_' + element.data[field.name]"
                  [fieldConfig]="field"></app-table-cell>
              </td>
            }
            <td>
              <app-main-table-content-v2-row-actions
                [tableConfig]="dataSource.tableConfig"
                [data]="element"></app-main-table-content-v2-row-actions>
            </td>
          </tr>
          @if (element.expanded) {
            <tr>
              <td [colSpan]="this.getTableDisplayFields().length + 3">
                <div class="expanded-area">
                  @if (dataSource.tabSelected.tableView.conditionals.length === 0) {
                    <div>
                      @for (field of this.getTableFieldsForExpandedArea(); track field) {
                        <div>
                          <span> {{ field.label }}: </span>
                          <span>
                            <app-form-field
                              [rowData]="element.data"
                              [type]="field.type"
                              [data]="element.data[field.name]"
                              [fieldConfig]="field"></app-form-field>
                          </span>
                        </div>
                      }
                    </div>
                  }
                  @if (dataSource.tabSelected.tableView.conditionals.length > 0) {
                    <div>
                      <app-expanded-row
                        [element]="element.data"
                        [menuConfig]="dataSource.tableConfig"
                        [conditional]="dataSource.tabSelected.tableView.conditionals[0]"></app-expanded-row>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
</div>

@if (loading) {
  <app-main-table-content-v2-loading></app-main-table-content-v2-loading>
}
